var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepairs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#e6007e;}.b,.c{fill-rule:evenodd;}.c{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13,.628,3.166,8.1a.5.5,0,0,0,.3.9H4.976l.476,9.525a.5.5,0,0,0,.5.475h14.1a.5.5,0,0,0,.5-.475L21.024,9h1.507a.5.5,0,0,0,.3-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M10.5,16.5h5a.5.5,0,0,1,0,1h-5a.5.5,0,0,1,0-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.5,7.5a1.5,1.5,0,0,0,3,0h0v-3A2.5,2.5,0,0,1,17,7v.1A5,5,0,0,1,15.123,11l-.623.5v4h-3v-4l-.623-.5A5,5,0,0,1,9,7.1V7a2.5,2.5,0,0,1,2.5-2.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepairs);
export default __webpack_public_path__ + "static/media/repairs.ec7fdff6438ab98b2e8ddfd756fdd2fd.svg";
export { ForwardRef as ReactComponent };